import z from "zod";
import { timestampSchema } from "./firestore";

export const userDocumentSchema = z.object({
  userId: z.string(),
  email: z.string().nullable(),
  createdAt: timestampSchema,
});

export interface IUserDocument extends z.infer<typeof userDocumentSchema> {
  id: string;
}
